/**
 * /execution/control-tower — re-entry into existing ControlTower page.
 *
 * Reuses ControlTower; does NOT fork. The import keeps the surface canonical.
 */
import ControlTower from "@/pages/ControlTower";
export default function ExecutionControlTowerPage() {
  return <ControlTower />;
}
